__turbopack_context__.v({
  "card-container": "style-module-scss-module__IDYjNG__card-container",
  "card-content": "style-module-scss-module__IDYjNG__card-content",
  "cards": "style-module-scss-module__IDYjNG__cards",
  "component": "style-module-scss-module__IDYjNG__component",
  "heading": "style-module-scss-module__IDYjNG__heading",
  "number": "style-module-scss-module__IDYjNG__number",
  "picture": "style-module-scss-module__IDYjNG__picture",
  "picture-container": "style-module-scss-module__IDYjNG__picture-container",
  "text": "style-module-scss-module__IDYjNG__text",
  "text-content": "style-module-scss-module__IDYjNG__text-content",
  "text-content-title": "style-module-scss-module__IDYjNG__text-content-title",
});
